import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink, Bell } from "lucide-react";
import telegramQR from "@/assets/telegram-qr.png";

const TELEGRAM_BOT_LINK = "https://t.me/FlowMkt_bot";
const TELEGRAM_APP_LINK = "https://t.me/FlowMkt_bot/flow";

export function TelegramAnnouncementCard() {
  return (
    <Card className="border-primary/30 bg-gradient-to-br from-primary/10 via-card/80 to-purple-500/10 backdrop-blur-sm overflow-hidden">
      <CardContent className="p-5">
        <div className="flex flex-col items-center text-center space-y-4">
          {/* Header */}
          <div className="space-y-1">
            <h3 className="text-lg font-bold text-foreground">
              FLOW Telegram
            </h3>
            <p className="text-sm text-muted-foreground">
              Trade NFTs and get live notifications
            </p>
          </div>

          {/* QR Code */}
          <a 
            href={TELEGRAM_BOT_LINK} 
            target="_blank" 
            rel="noopener noreferrer"
            className="block transition-transform hover:scale-105"
          >
            <img 
              src={telegramQR} 
              alt="FLOW Telegram Bot QR Code" 
              className="w-36 h-36 rounded-xl shadow-lg"
            />
          </a>

          {/* Bot Handle */}
          <p className="text-sm font-medium text-primary">
            @FlowMkt_bot
          </p>

          {/* Two Buttons */}
          <div className="w-full space-y-2">
            {/* Trading App Button */}
            <Button 
              asChild
              variant="outline"
              className="w-full border-primary/50 hover:bg-primary/10"
            >
              <a href={TELEGRAM_APP_LINK} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="w-4 h-4 mr-2" />
                Open App
              </a>
            </Button>

            {/* Notifications Button */}
            <Button 
              asChild
              variant="ghost"
              className="w-full text-muted-foreground hover:text-foreground"
            >
              <a href={TELEGRAM_BOT_LINK} target="_blank" rel="noopener noreferrer">
                <Bell className="w-4 h-4 mr-2" />
                Receive Notifications
              </a>
            </Button>
            <p className="text-xs text-muted-foreground">
              Tap to get alerts for new NFTs and sales
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
